<div class="card mt-2">
  <div class="card-header">Finance</div>
  <div class="card-body">
    <div>
      <nz-skeleton class="d-flex" [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
        <ul class="nav gap-3 d-flex">
          <li class="nav-item active">
            <a class="nav-link active" aria-current="page">Balance History</a>
          </li>
          <li class="nav-item" *ngIf="isEnterprise">
            <a class="nav-link" routerLink="/finance/commission"
              >Commission Withdrawal</a
            >
          </li>
        </ul>
      </nz-skeleton>
    </div>
    <div class="mt-5 mb-3 row">
      <div class="col-xl-4 col">
        <nz-skeleton class="d-flex" [nzLoading]="loading" [nzActive]="true">
          <app-withdrawl-card />
        </nz-skeleton>
      </div>
    </div>
    <div class="divider"></div>
    <nz-skeleton class="d-flex col-12 mt-3" [nzLoading]="loading" [nzActive]="true">
    <div class="mt-3 col-12">
        <app-table-riwayat-penarikan-saldo></app-table-riwayat-penarikan-saldo>
      </div>
    </nz-skeleton>
  </div>
</div>
